/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useState } from 'react';
import cx from 'classnames';
import { SmartLink as Link } from '@/utils/smartLink';
import azCommonStyles from '@/theme/globals.module.scss';
import { kebabCase } from '@/utils/kebabCase';
import styles from './styles.module.scss';
import type { MappedSearchRecord } from '../interface';
import NextImage from '@/components/NextImage';

const comingSoonImg = {
  src: '/images/product-photo-coming-soon-m.jpg',
};

type SearchResultProductProps = {
  content: MappedSearchRecord;
  searchText: string | undefined;
};

export const SearchResultProduct = ({
  content,
  searchText,
  ...linkProps
}: SearchResultProductProps) => {
  const url = content.propertyMap.P_ProductUrl;
  const pathUrl =
    (Array.isArray(url) && url[0] + (searchText ? `&searchText=${searchText}` : '')) || '#';

  const [imgSrc, setImgSrc] = useState(content.propertyMap.P_ProductImageUrl[0]);

  return (
    <Link
      {...linkProps}
      samePage
      to={pathUrl}
      data-testid={`${kebabCase(content.propertyMap.P_ProductDisplayName[0])}-search-result-link`}
    >
      <div className={styles.imgPlaceHolder}>
        <NextImage
          id={`search-result-image-${kebabCase(content.propertyMap.P_ProductDisplayName[0])}`}
          src={imgSrc}
          alt=""
          width={140}
          height={140}
          onError={() => {
            setImgSrc(comingSoonImg.src);
          }}
          data-searchresultposition={content.searchResultPosition}
        />
      </div>
      <span
        id={`search-result-text-${kebabCase(content.propertyMap.P_ProductDisplayName[0])}`}
        className={cx(
          azCommonStyles['az-body-2-regular'],
          azCommonStyles['az-margin-top-xxs'],
          styles.resultHeader,
          styles.resultHeaderText
        )}
      >
        {content.propertyMap.P_ProductDisplayName}
      </span>
    </Link>
  );
};
